import { useQuery } from 'react-query';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

import { SettingsData, SettingsResponse } from '@common/types/api';
import { SETTINGS_ENDPOINT } from '@constants/endpoints';
import { api } from '@services';
import { eventfyStorage } from '@services';
import { TWENTY_FOUR_HOURS } from '@constants';

export const fetchEventData = async () => {
  const { data } = await api.get<SettingsResponse>(
    `${SETTINGS_ENDPOINT}?include=custom`,
  );

  return data.data;
};

export const useEventQuery = () => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language || 'br';

  return useQuery<SettingsData, AxiosError>(
    ['event-settings', currentLang],
    fetchEventData,
    {
      cacheTime: TWENTY_FOUR_HOURS,
      staleTime: TWENTY_FOUR_HOURS,
      placeholderData: () => eventfyStorage.getItem<SettingsData>('event'),
      onSuccess: (data) => eventfyStorage.setItem('event', data),
    },
  );
};
